export const SCHEDULE_RANGE_OPTIONS = [
  {
    label: "1 week",
    days: 7,
    description: "Next 7 days",
  },
  {
    label: "2 weeks",
    days: 14,
    description: "Next 14 days",
  },
  {
    label: "1 month",
    days: 30,
    description: "Next 30 days",
  },
];

export function toApiDateTime(date) {
  return date.toISOString().slice(0, 19);
}

export function getScheduleRange(days = 7) {
  const start = new Date();
  start.setHours(0, 0, 0, 0);

  const end = new Date(start);
  end.setDate(start.getDate() + days);

  return { start, end };
}

export function getDefaultScheduleRange() {
  return getScheduleRange(7);
}

export function getScheduleRangeLabel(days) {
  const option = SCHEDULE_RANGE_OPTIONS.find((item) => item.days === days);
  return option?.label || `${days} days`;
}

export function getScheduleRangeDaysFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const days = Number(params.get("days"));
  const option = SCHEDULE_RANGE_OPTIONS.find((item) => item.days === days);
  return option?.days || 7;
}

export function getScheduleRangeSearch(days) {
  const option = SCHEDULE_RANGE_OPTIONS.find((item) => item.days === days);
  return `?days=${option?.days || 7}`;
}

export function formatDateTime(value) {
  if (!value) {
    return "Date unavailable";
  }

  return new Date(value).toLocaleString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatDate(value) {
  if (!value) {
    return "Date unavailable";
  }

  return new Date(value).toLocaleDateString([], {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function groupScheduleByDate(assignments) {
  return (assignments || []).reduce((groups, assignment) => {
    const key = formatDate(assignment.start);
    groups[key] = groups[key] || [];
    groups[key].push(assignment);
    return groups;
  }, {});
}
